"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ButtonStyle_1 = tslib_1.__importDefault(require("./ButtonStyle"));
const fmko_ts_common_1 = require("fmko-ts-common");
class StyledButton extends fmko_ts_common_1.Widget {
    constructor(args) {
        super();
        this.element = document.createElement("button");
        this.spanElement = document.createElement("span");
        this.element.appendChild(this.spanElement);
        // When used through IoC, it has no args
        if (!args) {
            return;
        }
        if (typeof args === "string") {
            // @ts-ignore - we know that it's the old args if the first argument is a string, because ButtonStyle resolves to a string
            const [style, text, clickHandler] = arguments;
            this.spanElement.textContent = text;
            this.setStyle(style);
            this.element.classList.add("btn-animate-hover");
            if (clickHandler) {
                this.addClickHandler(clickHandler);
            }
        }
        else {
            const { style, text, clickHandler, buttonImage, animateHover = true, disableDuringEvent = true, testIdentifier } = args;
            this.spanElement.textContent = text;
            this.disableDuringEvent = disableDuringEvent;
            this.setStyle(style ?? ButtonStyle_1.default.DEFAULT);
            this.setAnimateHover(animateHover);
            if (clickHandler) {
                this.addClickHandler(clickHandler);
            }
            if (buttonImage) {
                this.element.classList.add("btn-with-image", buttonImage);
            }
            if (testIdentifier) {
                this.element.dataset.cy = testIdentifier;
            }
        }
    }
    isDisabledDuringEvent() {
        return this.disableDuringEvent;
    }
    setDisableDuringEvent(disableDuringEvent) {
        this.disableDuringEvent = disableDuringEvent;
    }
    setStyle(style) {
        this.element.className = style;
    }
    setAnimateHover(shouldAnimate) {
        this.element.classList.toggle("btn-animate-hover", shouldAnimate);
    }
    /**
     * @deprecated
     * Dangerous set html use {@link setText instead}
     * @param html
     */
    setHtml(html) {
        this.spanElement.innerHTML = fmko_ts_common_1.HTMLUtils.sanitizeHTML(html);
    }
    setText(text) {
        this.spanElement.textContent = text;
    }
    isEnabled() {
        return (0, fmko_ts_common_1.isEnabled)(this.element);
    }
    setEnabled(enabled) {
        (0, fmko_ts_common_1.setEnabled)(this.element, enabled);
    }
    click() {
        this.element.click();
    }
    addClickHandler(callback) {
        this.element.addEventListener("click", async (event) => {
            if (this.isEnabled()) {
                if (this.disableDuringEvent) {
                    this.setEnabled(false);
                    try {
                        await callback(event);
                    }
                    catch (error) {
                        throw error;
                    }
                    finally {
                        this.setEnabled(true);
                    }
                }
                else {
                    await callback(event);
                }
            }
        });
    }
}
exports.default = StyledButton;
//# sourceMappingURL=StyledButton.js.map